module.exports = __webpack_public_path__ + "img/folder.9454c03b.png";